import i18n from '@/i18n';
import {MedicationForm} from '@/services/graphqlHooks';

const medicationForm = {
  [MedicationForm.Tablet]: i18n.t('Tablet'),
  [MedicationForm.Capsule]: i18n.t('Capsule'),
  [MedicationForm.Injection]: i18n.t('Injection'),
  [MedicationForm.Syrup]: i18n.t('Syrup'),
  [MedicationForm.Ointment]: i18n.t('Ointment'),
  [MedicationForm.Drops]: i18n.t('Drops'),
  [MedicationForm.Spray]: i18n.t('Spray'),
  [MedicationForm.Plaster]: i18n.t('Plaster'),
  [MedicationForm.TransdermalSystem]: i18n.t('Transdermal System'),
  [MedicationForm.Inhalation]: i18n.t('Inhalation'),
  [MedicationForm.Aerosol]: i18n.t('Aerosol'),
  [MedicationForm.Other]: i18n.t('Other'),
} as Record<MedicationForm, string>;

export default medicationForm;
